import { Injectable } from '@angular/core';
import {
    FEATURE,
    FEATURE_CERTIFICATE,
    FEATURE_LOGBOOK,
    FEATURE_ORDERS,
    FEATURE_REPORTS_LABORVSSALES,
    FEATURE_REPORTS_NOSHOW,
    FEATURE_REPORTS_STARTER,
    FEATURE_REPORTS_TIPSVSSALES
} from '@core/auth/feature-id';
import { SubscriptionTier } from '@core/models/billing/subscription-tier';
import { IAppState } from '@core/state/app/app-state';
import { getSubscription } from '@core/state/billing/billing-selectors';
import { Store } from '@ngrx/store';
import { take } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FeaturePolicyService {
    constructor(
        private store$: Store<IAppState>
    ) {}

    public isFeatureAvailable(features: any, featureId: string): boolean {
        let isAllowed = false;

        if (featureId) {
            switch (featureId) {
                case FEATURE.BILLING:
                    isAllowed = features && features.billing;
                    break;

                case FEATURE.UPGRADE:
                case FEATURE.UPGRADE_FROM_TRIAL:
                case FEATURE.BILLING_ALERT:
                case FEATURE.BILLING_BILLINGANDPAYMENTS:
                    isAllowed = features && features.billing;
                    break;

                case FEATURE_LOGBOOK:
                    this.store$.select(getSubscription)
                        .pipe(take(1))
                        .subscribe((subscription) => {
                            isAllowed = !!(
                                subscription &&
                                (subscription?.metadata?.tier ===
                                    SubscriptionTier.STARTER ||
                                    subscription?.metadata?.tier ===
                                        SubscriptionTier.PREMIUM ||
                                    subscription?.metadata?.tier ===
                                        SubscriptionTier.ENTERPRISE ||
                                    subscription?.metadata?.tier ===
                                        SubscriptionTier.FREEBIE) &&
                                (subscription.isTrial ||
                                    subscription.isTrialCancelling ||
                                    subscription.isSubscribed ||
                                    subscription.isSubscribedCancelling)
                            );
                        });
                    break;

                case FEATURE_CERTIFICATE:
                case FEATURE.ATTENDANCE_REPORTS:
                    this.store$.select(getSubscription)
                        .pipe(take(1))
                        .subscribe((subscription) => {
                            isAllowed = !!(
                                subscription &&
                                (subscription?.metadata?.tier ===
                                    SubscriptionTier.PREMIUM ||
                                    subscription?.metadata?.tier ===
                                        SubscriptionTier.ENTERPRISE ||
                                    subscription?.metadata?.tier ===
                                        SubscriptionTier.FREEBIE) &&
                                (subscription.isTrial ||
                                    subscription.isTrialCancelling ||
                                    subscription.isSubscribed ||
                                    subscription.isSubscribedCancelling)
                            );
                        });
                    break;

                case FEATURE.ATTENDANCE_UPGRADE:
                case FEATURE.ATTENDANCE_TIMECLOCK:
                    this.store$.select(getSubscription)
                        .pipe(take(1))
                        .subscribe((subscription) => {
                            isAllowed = !!(
                                !subscription ||
                                (subscription && subscription.isCancelled)
                            );
                        });
                    break;

                case FEATURE.ATTENDANCE_TRIAL:
                    isAllowed = features && !features.billing;
                    break;

                case FEATURE.ATTENDANCE:
                case FEATURE.WORKER_PROFILE_CERTIFICATIONS_EDIT:
                    isAllowed = features && features.attendance;
                    break;

                // case FEATURE_REPORTS_NOSHOW:
                // case FEATURE_REPORTS_LABORVSSALES:
                // case FEATURE_REPORTS_TIPSVSSALES:
                // case FEATURE_REPORTS_STARTER:
                // case FEATURE_ORDERS:
                //     isAllowed = this.can(featureId);
                //     break;

                default:
                    isAllowed = true;
                    break;
            }
        }

        return isAllowed;
    }
}